<template>
  <div>
    <filters-button>
      <button-component
        color="dark"
        @click="handleFiltersClick"
        type="half-right"
      >
        Anuluj
      </button-component>
    </filters-button>

    <filters-header
      :count="filtersCount"
      @click="filter"
    />

    <filters-list
      :available-filters="availableFilters"
      :filters="filters"
      @toggleFilter="toggleFilter"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { SET_FILTERS } from '@/store/mutation-types'

import FiltersButton from '@/containers/Settings/FiltersButton'
import FiltersHeader from '@/containers/Settings/FiltersHeader'
import FiltersList from '@/containers/Settings/FiltersList'
import ButtonComponent from '@/components/Button'

export default {
  components: {
    ButtonComponent,
    FiltersButton,
    FiltersList,
    FiltersHeader
  },
  data () {
    return {
      filters: [],
      areFiltersOpen: false
    }
  },
  computed: {
    ...mapGetters(['availableFilters']),
    ...mapState({
      activeFilters: state => state.filters.filters
    }),
    isFilterSelected () {
      return this.filters.length || this.filtersCount
    },
    filtersCount () {
      return this.filters.length
    }
  },
  watch: {
    activeFilters () {
      this.setInternalFilters()
    }
  },
  created () {
    this.fetchAvailableFilters()
    this.setFilters(this.filtersQueryToArray())
  },
  methods: {
    ...mapActions(['fetchAvailableFilters']),
    ...mapMutations({ setFilters: SET_FILTERS }),
    setInternalFilters () {
      this.filters = this.activeFilters
    },
    filter () {
      this.$emit('close')
      this.setFilters(this.filters)
    },
    toggleFilter (filter) {
      this.filters = this.filters.find(item => item === filter)
        ? this.filters.filter(item => item !== filter)
        : [...this.filters, filter]
    },
    handleFiltersClick () {
      this.$emit('close')
    },
    filtersQueryToArray () {
      const { filters } = this.$route.query
      return filters ? filters.split(',') : []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Settings/FiltersContainer.vue